import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIcon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconIcon"><Path fillRule="evenodd" clipRule="evenodd" d="M17.0039 6H22V21H2V6H7.00391V2H17.0039V6ZM11 12.5H9V14.5H11V16.5H13V14.5H15V12.5H13V10.5H11V12.5ZM9.00391 6H15.0039V4H9.00391V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconIcon;
